(function(){
'use strict';
const VALUES={A:1,I:1,J:1,Q:1,Y:1,B:2,K:2,R:2,C:3,G:3,L:3,S:3,D:4,M:4,T:4,E:5,H:5,N:5,X:5,U:6,V:6,W:6,O:7,Z:7,F:8,P:8};

const SINGLES={
1:{planet:"Sun",title:"Number 1",text:"Cheiro connects 1 with individuality, ambition, leadership, independence and the urge to originate. It tends to act directly and prefers to lead rather than follow.",negative:"Cheiro also describes Number 1 as obstinate, strongly determined, resistant to restraint, and inclined to insist on its own direction. In excess, independence can become stubbornness or an unwillingness to be directed by others."},
2:{planet:"Moon",title:"Number 2",text:"Cheiro connects 2 with imagination, sensitivity, gentleness, receptivity and artistic feeling. It is more responsive than forceful and often works through cooperation.",negative:"Cheiro lists restlessness, an unsettled nature, lack of continuity in plans, lack of self-confidence, oversensitivity, and a tendency toward discouragement or melancholy when surroundings are unhappy."},
3:{planet:"Jupiter",title:"Number 3",text:"Cheiro associates 3 with ambition, order, authority, discipline and advancement. It often seeks structure, responsibility and recognition.",negative:"Cheiro says the faults of Number 3 can include being dictatorial, 'laying down the law,' insisting on one's own ideas, pride, dislike of being under obligation to others, and chafing under restraint. These tendencies can create unnecessary opposition or enemies."},
4:{planet:"Uranus",title:"Number 4",text:"Cheiro treats 4 as unconventional, individualistic and often opposed to ordinary rules. It can bring unusual turns, originality and a tendency to see matters differently from the crowd.",negative:"Cheiro describes Number 4 as prone to taking the opposite side, creating opposition and secret enemies, rebelling against rules, and finding worldly or material success more difficult. He also calls its chief faults high nervous sensitivity, easily wounded feelings, loneliness, isolation, discouragement and melancholy when success is lacking."},
5:{planet:"Mercury",title:"Number 5",text:"Cheiro associates 5 with versatility, movement, communication, quick thought, business ability and change. It is adaptable, curious and mentally active.",negative:"Cheiro describes Number 5 as highly strung, living 'on the nerves,' craving excitement, acting impulsively, disliking slow or plodding work, and being strongly drawn to speculation, quick-money ideas and risk. Its speed and adaptability can become restlessness or impulsive decision-making."},
6:{planet:"Venus",title:"Number 6",text:"Cheiro associates 6 with love, harmony, attraction, beauty, art, home and responsibility toward others. It seeks balance and tends to draw people through warmth or charm.",negative:"Cheiro says Number 6 can become obstinate and unyielding in carrying out plans. In deep attachment it may become excessively devoted, while discord or jealousy can be especially difficult to tolerate. When angered, it may refuse opposition and fight intensely for a person, cause or sense of duty."},
7:{planet:"Neptune",title:"Number 7",text:"Cheiro links 7 with independence, intuition, reflection, originality and the unusual. It often prefers depth, privacy, specialized knowledge and an inner life.",negative:"Cheiro describes Number 7 as restless and strongly drawn to change and travel. Its good ideas may remain unrealized if they are not carried through, and he portrays it as less concerned with material matters and sometimes anxious about the future. Its independence can also make it resistant to conventional paths."},
8:{planet:"Saturn",title:"Number 8",text:"Cheiro treats 8 as serious, responsible and powerful, but also connected with delay, material tests, fate-like circumstances and heavy obligations. Endurance is a major theme.",negative:"Cheiro gives Number 8 some of his strongest cautions: feeling misunderstood or lonely, going to extremes, appearing cold or undemonstrative, creating bitter opposition, and experiencing marked highs and lows rather than an easy middle course. He also associates the number with upheaval, fatalism, sorrow, loss and difficult material tests."},
9:{planet:"Mars",title:"Number 9",text:"Cheiro associates 9 with energy, courage, force, ambition, conflict and strong will. It can be intensely active, determined and emotionally powerful.",negative:"Cheiro describes Number 9 as hasty in temper, impulsive and strongly independent. When overemphasized it may create enemies, strife and opposition. He says its greatest dangers arise from foolhardiness and impulsiveness in both words and actions, with a tendency toward quarrels and excesses of temper."}
};


const STRONG_DATES={
1:{
  dates:"1st, 10th, 19th, and 28th of any month",
  periods:"March 21–April 28 and July 21–August 28",
  note:"Cheiro describes the Sun as elevated or especially powerful in these periods and says Number 1 qualities are more strongly marked then."
},
2:{
  dates:"2nd, 11th, 20th, and 29th of any month",
  periods:"June 20–July 27",
  note:"Cheiro calls this the House of the Moon and says Number 2 characteristics and its own-number dates are especially strong in this period."
},
3:{
  dates:"3rd, 12th, 21st, and 30th of any month",
  periods:"February 19–March 20 (with Cheiro’s cusp extending to March 27) and November 21–December 20 (cusp extending to December 27)",
  note:"Cheiro calls these the periods of the 3 and says Number 3 dates are especially significant when they fall within them."
},
4:{
  dates:"4th, 13th, 22nd, and 31st of any month",
  periods:"June 21–July 20 (with Cheiro’s cusp extending to July 27) and July 22–the end of August",
  note:"Cheiro describes these as strong Sun-and-Moon periods for Number 4 and says its individuality is more pronounced then."
},
5:{
  dates:"5th, 14th, and 23rd of any month",
  periods:"May 21–June 20 (with Cheiro’s cusp extending to June 27) and August 21–September 20 (cusp extending to September 27)",
  note:"Cheiro calls these the periods of the 5 and says Number 5 characteristics and dates are more strongly marked during them."
},
6:{
  dates:"6th, 15th, and 24th of any month",
  periods:"April 20–May 20 (with Cheiro’s cusp extending to May 27) and September 21–October 20 (cusp extending to October 27)",
  note:"Cheiro calls these the House or period of the 6 and says Number 6 influence is especially pronounced then."
},
7:{
  dates:"7th, 16th, and 25th of any month",
  periods:"June 21–July 20 (with Cheiro’s cusp extending to July 27), with a lesser influence continuing to the end of August",
  note:"Cheiro calls the main interval the period of the 7 and says its own-number dates are especially strong within it."
},
8:{
  dates:"8th, 17th, and 26th of any month",
  periods:"December 21–January 20 (with Cheiro’s cusp extending to January 27), then continuing through about February 19 (cusp extending to February 26)",
  note:"Cheiro calls this the period of the 8 and says Number 8 dates become especially important within it."
},
9:{
  dates:"9th, 18th, and 27th of any month",
  periods:"March 21–April 19 (with Cheiro’s cusp extending to April 26) and October 21–November 20 (cusp extending to November 27)",
  note:"Cheiro calls these the periods of the 9 and says Number 9 dates are especially powerful when they occur within them."
}
};

const C={
10:{title:"Wheel of Fortune",status:"good",text:"Honor, confidence and the power to carry plans through, while still implying the turning nature of fortune."},
11:{title:"Hidden dangers",status:"warn",text:"A warning of concealed difficulties, opposition, trials or treachery from others."},
12:{title:"Sacrifice / anxiety",status:"warn",text:"Mental strain and the danger of being used, sacrificed or drawn into other people's designs."},
13:{title:"Change and upheaval",status:"mixed",text:"Powerful change, altered plans and unexpected circumstances. Cheiro did not treat 13 as automatically unlucky, but he did treat it as a number that demands alertness."},
14:{title:"Movement with risk",status:"mixed",text:"Movement, business, combinations and change can prosper, but imprudence or risks created by others require caution."},
15:{title:"Magic and magnetism",status:"good",text:"Personal magnetism, eloquence, artistic power and persuasion. Cheiro especially favors it for gaining money, gifts, favors or influence through others."},
16:{title:"Shattered Citadel",status:"warn",text:"A warning of sudden reversal, accident, defeat of plans or an unexpected turn. Cheiro advises preparation and caution."},
17:{title:"Star of the Magi",status:"good",text:"A highly fortunate spiritual number associated with peace, love, rising above trials and leaving a lasting name, with Cheiro's special caveat about 4-and-8 combinations."},
18:{title:"Material conflict",status:"warn",text:"Conflict, deception, upheaval and danger through quarrels, opposing forces or the elements. Cheiro advises great care."},
19:{title:"The Sun",status:"good",text:"One of Cheiro's most fortunate numbers, promising happiness, success, esteem, honor and success in plans."},
20:{title:"The Awakening",status:"mixed",text:"A call to new purpose or ambition. It can awaken plans and ideals, although worldly results may be delayed."},
21:{title:"Crown of the Magi",status:"good",text:"Advancement, honors and victory after sustained effort. Cheiro treats it as favorable for future plans."},
22:{title:"Illusion / false judgment",status:"warn",text:"A warning against delusion, poor judgment and allowing other people's influence to create danger."},
23:{title:"Royal Star of the Lion",status:"good",text:"Success, protection and help from people in authority. Cheiro regards it as one of the strongest future-event numbers."},
24:{title:"Assistance and gain",status:"good",text:"Help from people of position and favorable gains through affection, alliance, association or partnership."},
25:{title:"Strength through experience",status:"good",text:"Benefits gained through experience and observation after earlier tests or struggle. Favorable for future matters."},
26:{title:"Partnership warning",status:"warn",text:"A serious warning about loss through partnerships, speculation, unions, association with others or bad advice."},
27:{title:"The Sceptre",status:"good",text:"Authority, power, command and reward from productive or creative intellect. Favorable for carrying out one's own plans."},
28:{title:"Contradictions",status:"warn",text:"Great promise mixed with risk of loss through trust, opposition, competition or law, sometimes requiring a fresh start."},
29:{title:"Uncertainty and deception",status:"warn",text:"Uncertainty, unreliable associates, treachery, unexpected danger and emotional disappointment."},
30:{title:"Mental plane",status:"neutral",text:"Thought, retrospection and mental superiority. Material results depend strongly on the person's outlook and choices."},
31:{title:"Isolation",status:"mixed",text:"Self-contained, solitary and mentally independent. Cheiro does not regard it as especially fortunate for worldly material success."},
32:{title:"Magical power",status:"good",text:"A fortunate number when one trusts one's own judgment; plans may suffer when surrendered to other people's stubbornness."},
33:{title:"As 24",status:"good",text:"Assistance, alliance and favorable gains through others."},
34:{title:"As 25",status:"good",text:"Strength and benefit gained through experience and observation."},
35:{title:"As 26",status:"warn",text:"A warning concerning partnerships, speculation and bad advice."},
36:{title:"As 27",status:"good",text:"Authority, command and reward from one's own productive ideas."},
37:{title:"Fortunate partnerships",status:"good",text:"Good friendships, love connections and partnerships; favorable in future-event calculations."},
38:{title:"As 29",status:"warn",text:"Uncertainty, deception, unreliable associates and unexpected danger."},
39:{title:"As 30",status:"neutral",text:"Mental power and retrospection, with material results depending on outlook."},
40:{title:"As 31",status:"mixed",text:"Self-containment and isolation, not especially favorable materially."},
41:{title:"As 32",status:"good",text:"Fortunate when personal judgment is maintained."},
42:{title:"As 24",status:"good",text:"Assistance from others and favorable gains through alliances."},
43:{title:"Upheaval and prevention",status:"warn",text:"An unfortunate warning number associated with upheaval, strife, failure and obstruction."},
44:{title:"As 26",status:"warn",text:"Serious caution around association, partnerships, speculation and advice."},
45:{title:"As 27",status:"good",text:"Authority, power and reward from productive intellect."},
46:{title:"As 37",status:"good",text:"Fortunate friendships, love combinations and partnerships."},
47:{title:"As 29",status:"warn",text:"Uncertainty, deception and unexpected danger."},
48:{title:"As 30",status:"neutral",text:"Thoughtful and retrospective, with material outcome depending on outlook."},
49:{title:"As 31",status:"mixed",text:"Independence and isolation, not especially favorable materially."},
50:{title:"As 32",status:"good",text:"Favorable when personal judgment is maintained."},
51:{title:"Warrior",status:"mixed",text:"Powerful and promising sudden advancement or leadership, but also carrying a warning of enemies and danger."},
52:{title:"As 43",status:"warn",text:"Upheaval, strife, failure and obstruction."}
};

function ds(n){return String(Math.abs(n)).split("").reduce((a,b)=>a+Number(b),0)}
function reduceN(n){while(n>9)n=ds(n);return n}
function reduction(n){const a=[n];while(n>9){n=ds(n);a.push(n)}return a.join(" → ")}
function esc(s){return String(s).replace(/[&<>"']/g,m=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#039;"}[m]))}
function localDate(v){if(!v)return null;let[y,m,d]=v.split("-").map(Number);return new Date(y,m-1,d)}
function pretty(d){return d.toLocaleDateString(undefined,{month:"long",day:"numeric",year:"numeric"})}
function calcWord(word){
  const letters=[...word.toUpperCase().replace(/[^A-Z]/g,"")];
  const nums=letters.map(x=>VALUES[x]).filter(Boolean);
  const total=nums.reduce((a,b)=>a+b,0);
  return {word,letters,nums,total,root:reduceN(total)};
}
function calcName(name){
  const words=name.trim().split(/\s+/).map(calcWord).filter(w=>w.letters.length);
  if(!words.length)return null;
  const compound=words.length===1?words[0].total:words.reduce((a,w)=>a+w.root,0);
  return {words,compound,root:reduceN(compound)};
}
function info(n){
  if(n>=10&&n<=52&&C[n])return C[n];
  if(n>=1&&n<=9)return {title:SINGLES[n].title,status:"neutral",text:SINGLES[n].text};
  return {title:"Outside Cheiro's 1–52 reference",status:"neutral",text:"Cheiro says practical compound-number symbolism need not proceed beyond 52."};
}
function label(s){return {good:"Favorable",warn:"Warning",mixed:"Mixed / caution",neutral:"Neutral / conditional"}[s]||"Result"}
function dateTest(nameRoot,birthRoot,day){
  const dr=reduceN(day), c1=nameRoot+dr, r1=reduceN(c1), c2=r1+birthRoot, r2=reduceN(c2);
  return {day,dr,c1,r1,c2,r2,inf:info(c2)};
}
function harmony(nameRoot,birthRoot){
  if(nameRoot===birthRoot)return {symbol:"✓",short:"Strong match",text:`Your Name Number and Birth Number are both ${nameRoot}. In Cheiro's system this is the clearest form of numerical harmony: the name vibration reinforces the number given by the day of birth.`};
  if((nameRoot===4&&birthRoot===8)||(nameRoot===8&&birthRoot===4))
    return {symbol:"⚠",short:"4–8 combination",text:`Your Name Number ${nameRoot} and Birth Number ${birthRoot} form Cheiro's special 4-and-8 combination. He treats this pairing as unusually difficult in material affairs and emphasizes caution around major undertakings and name-number choices.`};
  if((birthRoot===4||birthRoot===8)&&[1,3,5,6].includes(nameRoot))
    return {symbol:"↗",short:"Cheiro exception",text:`Your Birth Number is ${birthRoot}, one of Cheiro's special 4/8 numbers, while your Name Number is ${nameRoot}. Cheiro specifically regarded 1, 3, 5 and 6 as stronger alternative vibrations for people born under 4 or 8, rather than intensifying the 4/8 pattern.`};
  return {symbol:"≈",short:"Different numbers",text:`Your Name Number is ${nameRoot} and your Birth Number is ${birthRoot}. They are not identical. Cheiro generally preferred the Name Number to harmonize with the Birth Number when possible, so this reading treats the two as distinct influences rather than a perfect reinforcement.`};
}
function render(root){
  const name=get(root,"name").value.trim();
  const b=localDate(get(root,"birth").value);
  const monthVal=get(root,"month").value;
  const n=calcName(name);
  if(!n||!b||!monthVal){alert("Please enter a name, birth date, and month.");return}
  const bd=b.getDate(), br=reduceN(bd), h=harmony(n.root,br);
  const [cy,cm]=monthVal.split("-").map(Number);
  const monthDate=new Date(cy,cm-1,1);

  get(root,"reportName").textContent=name;
  get(root,"reportBirth").textContent=`Born ${pretty(b)}`;

  get(root,"nameWords").innerHTML=n.words.map(w=>`
    <div class="wordblock">
      <div class="wordhead">
        <div class="wordname">${esc(w.word)}</div>
        <div class="wordnumbers">${w.nums.join(" + ")} = ${w.total} → ${w.root}</div>
      </div>
      <div class="chips">${w.letters.map((ch,i)=>`<div class="chip"><b>${ch}</b>${w.nums[i]}</div>`).join("")}</div>
    </div>`).join("");

  const roots=n.words.map(w=>w.root);
  get(root,"nameFormula").innerHTML=n.words.length===1
    ? `<strong>Name Key:</strong> ${n.words[0].nums.join(" + ")} = ${n.compound} → <strong>${n.root}</strong>.`
    : `<strong>Name Key:</strong> Cheiro reduces each commonly-used name word first, then combines the word numbers: ${roots.join(" + ")} = <strong>${n.compound}</strong> → <strong>${n.root}</strong>.`;

  get(root,"namePlanet2").textContent=SINGLES[n.root].planet;
  get(root,"nameSingleTitle").textContent=`Name Single ${n.root}`;
  get(root,"nameSingleReading").textContent=SINGLES[n.root].text;
  get(root,"nameSingleNegative").textContent=SINGLES[n.root].negative;
  get(root,"nameStrongDates").textContent=STRONG_DATES[n.root].dates;
  get(root,"nameStrongPeriods").textContent=STRONG_DATES[n.root].periods;
  get(root,"nameStrongNote").textContent=STRONG_DATES[n.root].note;

  get(root,"birthPlanet2").textContent=SINGLES[br].planet;
  get(root,"birthTitle").textContent=`Birth Number ${br}`;
  get(root,"birthReading").textContent=SINGLES[br].text;
  get(root,"birthCalcTitle").textContent=`Born on day ${bd}`;
  get(root,"birthCalcText").textContent=`Cheiro's Birth Number uses the day of the month, not the total of the full calendar date. Your birth day is ${bd}, which reduces to ${br}.`;
  get(root,"birthFormula").innerHTML=`Birth Number: <strong>${reduction(bd)}</strong>`;
  get(root,"harmonyReading").innerHTML=`<strong>${esc(h.short)}.</strong> ${esc(h.text)}`;



  // Calendar
  const daysInMonth=new Date(cy,cm,0).getDate();
  const firstDow=new Date(cy,cm-1,1).getDay();
  const cells=[];
  for(let i=0;i<firstDow;i++)cells.push(`<div class="day empty"></div>`);
  const goodDays=[];
  const allReceived=new Map();
  allReceived.set(n.compound,{label:"Name compound",n:n.compound});
  allReceived.set(n.root,{label:"Name single",n:n.root});
  allReceived.set(br,{label:"Birth number",n:br});
  n.words.forEach(w=>allReceived.set(w.total,{label:`${w.word} compound`,n:w.total}));

  for(let d=1;d<=daysInMonth;d++){
    const t=dateTest(n.root,br,d);
    allReceived.set(t.c2,{label:"Date-test compound",n:t.c2});
    if(t.inf.status==="good")goodDays.push(t);
    const cls=t.inf.status==="good"?"favorable":t.inf.status==="warn"?"warning":"";
    cells.push(`<div class="day ${cls}">
      <div class="n">${d}</div>
      <div class="res">${t.c2}/${t.r2}</div>
      <div class="status">${label(t.inf.status)}</div>
    </div>`);
  }
  get(root,"calendar").innerHTML=cells.join("");
  get(root,"calendarIntro").textContent=`${monthDate.toLocaleDateString(undefined,{month:"long",year:"numeric"})}: each day is tested with Name ${n.root} and Birth ${br}.`;
  get(root,"calendarExplanation").innerHTML=`Cheiro-style date test used here: <strong>Name single ${n.root}</strong> + reduced calendar day → reduce again → add <strong>Birth number ${br}</strong>. The resulting compound is interpreted using Cheiro's compound-number meanings.`;

  goodDays.sort((a,b)=>{
    const rank={23:1,19:2,21:3,17:4,15:5,27:6,24:7,25:8,37:9,32:10};
    return (rank[a.c2]||50)-(rank[b.c2]||50)||a.day-b.day;
  });
  get(root,"bestDates").innerHTML=(goodDays.length?goodDays.slice(0,9).map(t=>`
    <div class="numcard">
      <div class="label">${monthDate.toLocaleDateString(undefined,{month:"short"})} ${t.day}</div>
      <div class="num">${t.c2}/${t.r2}</div>
      <div><span class="badge good">Favorable</span></div>
      <div class="desc"><strong>${esc(t.inf.title)}</strong><br>${esc(t.inf.text)}</div>
    </div>`):`<div class="small">No dates in this month produced a compound classified as favorable in the abbreviated Cheiro library.</div>`).join("");

  // Received numbers: unique, sorted by appearance type loosely
  const arr=[...allReceived.values()];
  get(root,"receivedNumbers").innerHTML=arr.map(x=>{
    const inf=info(x.n), root=reduceN(x.n);
    return `<div class="numcard">
      <div class="label">${esc(x.label)}</div>
      <div class="num">${x.n}${x.n>9?` / ${root}`:""}</div>
      <div style="margin-top:5px"><span class="badge ${inf.status}">${label(inf.status)}</span></div>
      <div class="desc"><strong>${esc(inf.title)}</strong><br>${esc(inf.text)}</div>
    </div>`;
  }).join("");

  get(root,"report").style.display="block";
  root._summary=`Cheiro Numerology Reading for ${name}
Birth date: ${pretty(b)}
Name compound: ${n.compound}
Name single: ${n.root} (${SINGLES[n.root].planet})
Birth number: ${br} (${SINGLES[br].planet})
Name + Birth Compatibility: ${h.short}

Name: ${n.words.map(w=>`${w.word} ${w.total}→${w.root}`).join("; ")}
Name Key: ${n.compound}→${n.root}
Birth Number: ${bd}→${br}

Compatibility reading: ${h.text}`;
}


function get(root,key){
  return root ? root.querySelector(`[data-scn="${key}"]`) : null;
}

function init(root){
  if(!root || root.dataset.scnInitialized==="true") return;
  root.dataset.scnInitialized="true";

  const month=get(root,"month");
  if(month && !month.value){
    const now=new Date();
    month.value=`${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,"0")}`;
  }

  const generate=get(root,"generate");
  if(generate) generate.addEventListener("click",()=>render(root));

  const sample=get(root,"sample");
  if(sample){
    sample.addEventListener("click",()=>{
      get(root,"name").value="John Smith";
      get(root,"birth").value="1990-01-08";
      get(root,"month").value="2026-04";
      render(root);
    });
  }

  const copy=get(root,"copyReport");
  if(copy){
    copy.addEventListener("click",async()=>{
      if(!root._summary) return;
      try{
        await navigator.clipboard.writeText(root._summary);
        const old=copy.textContent;
        copy.textContent="Copied!";
        setTimeout(()=>copy.textContent=old,1200);
      }catch(e){
        alert("Copy was blocked by the browser. You can still select and copy the report manually.");
      }
    });
  }

  const printButton=get(root,"print");
  if(printButton){
    printButton.addEventListener("click",()=>window.print());
  }
}

function initAll(scope=document){
  scope.querySelectorAll("[data-scn-calculator]").forEach(init);
}

if(document.readyState==="loading"){
  document.addEventListener("DOMContentLoaded",()=>initAll(document));
}else{
  initAll(document);
}

document.addEventListener("shopify:section:load",(event)=>{
  const target=event.target;
  const root=target.matches && target.matches("[data-scn-calculator]")
    ? target
    : target.querySelector && target.querySelector("[data-scn-calculator]");
  if(root){
    root.dataset.scnInitialized="false";
    init(root);
  }
});

})();
